export const budgetCategoryFilters = [
  "all",
  "in-use",
  "unfunded",
  "overspent",
] as const;

export type BudgetCategoryFilter = (typeof budgetCategoryFilters)[number];

const labels: Record<BudgetCategoryFilter, string> = {
  all: "All",
  "in-use": "In use",
  unfunded: "Unfunded",
  overspent: "Overspent",
};

export function budgetCategoryFilterFrom(
  value: string,
): BudgetCategoryFilter {
  return budgetCategoryFilters.includes(value as BudgetCategoryFilter)
    ? (value as BudgetCategoryFilter)
    : "all";
}

export function budgetCategoryFilterLabel(
  filter: BudgetCategoryFilter,
): string {
  return labels[filter];
}

export function budgetCategoryMatchesFilter(
  states: string | undefined,
  filter: BudgetCategoryFilter,
): boolean {
  if (filter === "all") {
    return true;
  }

  return (states || "").split(/\s+/).includes(filter);
}

export function budgetCategoryFilterStatus(
  filter: BudgetCategoryFilter,
  visible: number,
  total: number,
): string {
  const noun = total === 1 ? "category" : "categories";
  if (filter === "all") {
    return `Showing all ${total} ${noun}.`;
  }

  return `Showing ${visible} of ${total} ${noun} for ${budgetCategoryFilterLabel(filter)}.`;
}

export function budgetCategoryFilterEmptyMessage(
  filter: BudgetCategoryFilter,
): string {
  if (filter === "all") {
    return "No categories are available.";
  }

  return `No categories match ${budgetCategoryFilterLabel(filter)}.`;
}
